import { useRouter } from 'next/compat/router';
import styled from 'styled-components';

interface ButtonProps {
	text: string;
}

const BackButton = ({ text }: ButtonProps) => {
	const router = useRouter();

	return (
		<Button onClick={() => router?.back()}>
			<ArrowWrapper>
				<img alt="Back Arrow" src="/images/icons/back-arrow.svg" />
			</ArrowWrapper>

			<span>{text}</span>
		</Button>
	);
};

const Button = styled.button`
	display: flex;
	margin: 0 auto;
	cursor: pointer;
	align-items: center;
	background-color: var(--color-purple-50);
	border-radius: 12px;
	padding: 10px 25px 10px 16px;
	font-family: var(--font-sans);

	font-size: 18px;
	line-height: 25px;
	text-align: center;
	color: var(--color-white);
	transition: 0.3s;

	&:focus {
		outline: none;
	}

	&:hover {
		background-color: var(--color-purple-90);
	}

	@media (max-width: 600px) {
		margin-top: 20px;
	}
`;

const ArrowWrapper = styled.span`
	display: block;
	position: relative;
	width: 26px;
	height: 26px;
	border-radius: 50%;
	background-color: var(--color-white);
	transform: rotate(-180deg);
	margin-right: 7px;

	img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
`;

export default BackButton;
